module.exports = __webpack_public_path__ + "img/code.d154323e.jpg";